import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddDeviceDetectionJobMutationVariables = Types.Exact<{
  input: Types.Device_Detection_Jobs_Insert_Input;
}>;


export type AddDeviceDetectionJobMutation = { __typename?: 'mutation_root', insert_device_detection_jobs_one?: { __typename?: 'device_detection_jobs', id: any, property_id: any, workspace_id?: any | null, organization_id?: any | null, status: string, input_files?: any | null, ai_response?: any | null, detected_devices?: any | null, detected_installed_products?: any | null, products_grouped_by_type?: any | null, created_at?: any | null, updated_at: any } | null };


export const AddDeviceDetectionJobDocument = gql`
    mutation addDeviceDetectionJob($input: device_detection_jobs_insert_input!) {
  insert_device_detection_jobs_one(object: $input) {
    id
    property_id
    workspace_id
    organization_id
    status
    input_files
    ai_response
    detected_devices
    detected_installed_products
    products_grouped_by_type
    created_at
    updated_at
  }
}
    `;
export type AddDeviceDetectionJobMutationFn = Apollo.MutationFunction<AddDeviceDetectionJobMutation, AddDeviceDetectionJobMutationVariables>;

/**
 * __useAddDeviceDetectionJobMutation__
 *
 * To run a mutation, you first call `useAddDeviceDetectionJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDeviceDetectionJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDeviceDetectionJobMutation, { data, loading, error }] = useAddDeviceDetectionJobMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDeviceDetectionJobMutation(baseOptions?: Apollo.MutationHookOptions<AddDeviceDetectionJobMutation, AddDeviceDetectionJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDeviceDetectionJobMutation, AddDeviceDetectionJobMutationVariables>(AddDeviceDetectionJobDocument, options);
      }
export type AddDeviceDetectionJobMutationHookResult = ReturnType<typeof useAddDeviceDetectionJobMutation>;
export type AddDeviceDetectionJobMutationResult = Apollo.MutationResult<AddDeviceDetectionJobMutation>;
export type AddDeviceDetectionJobMutationOptions = Apollo.BaseMutationOptions<AddDeviceDetectionJobMutation, AddDeviceDetectionJobMutationVariables>;